import { render } from "./BuyerView.vue?vue&type=template&id=a6eccd32"
import script from "./BuyerView.vue?vue&type=script&lang=js"
export * from "./BuyerView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__